import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { ACCEPT_CURVEBALL, SET_CURVEBALL_ACTIVATION, RETURN_CURVEBALL } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		title: "",
		request_dialogue: "",
		accept_button_text: "",
		deny_button_text: "",
		acceptance_bonuses: {},
		denial_penalties: {},
		cost: 0,
		return_if_denied: false,
		is_trick_purchase: false,
		trick: null,
		return_request: {},
		active: false,
		accepted: false,
		returning: false,
		videos: {},
	}),
	getters: {
		willReturn: (state) => state.return_if_denied && !state.returning,
		maxCost: (state) => (state.return_if_denied ? state.return_request.cost : state.cost),
		trickOwned: (state, getters, rootState) => state.is_trick_purchase
			&& rootState.game.tricks[state.trick].owned,
		servable: (state, getters, rootState) => (getters.maxCost <= rootState.game.balance.amount)
			&& !getters.trickOwned,
		budget: (state, getters, rootState, rootGetters) => ({
			id: state.id,
			title: state.title,
			allocated: state.cost,
			lastAllocation: 0,
			locked: true,
			order: rootGetters["game/budgets/count"] + 1,
			info_text: rootState.global.api.data.ui.curveballs.info_text,
		}),
	},
	actions: {
		activate({ commit, dispatch }) {
			commit(SET_CURVEBALL_ACTIVATION, { active: true });
			dispatch("preloadVideo");
		},
		preloadVideo({ dispatch, state }) {
			const manifest = [...Object.values(state.videos)];
			if (state.return_if_denied) {
				manifest.push(...Object.values(state.return_request?.videos));
			}

			dispatch("global/assets/loadManifest", manifest, ROOT_FLAG);
		},
		deactivate({ dispatch, commit, state, getters }) {
			if (state.accepted) {
				dispatch("game/budgets/remove", getters.budget, ROOT_FLAG);
			}
			commit(SET_CURVEBALL_ACTIVATION, { active: false });
		},
		accept({ dispatch, commit, state, getters }) {
			commit(ACCEPT_CURVEBALL);

			if (!state.returning) {
				dispatch("global/analytics/trackEvent", { ec: "Curveball", ea: state.title, el: "Accept" }, ROOT_FLAG);
				Object.entries(state.acceptance_bonuses).forEach(([scoreId, modifier]) => {
					dispatch(`game/scores/${scoreId}/modify`, { amount: modifier }, ROOT_FLAG);
				});
			}

			if (state.is_trick_purchase) {
				dispatch(`game/tricks/${state.trick}/acquire`, {}, ROOT_FLAG);
			}

			dispatch("game/budgets/add", getters.budget, ROOT_FLAG);
		},
		deny({ dispatch, state }) {
			dispatch("global/analytics/trackEvent", { ec: "Curveball", ea: state.title, el: "Deny" }, ROOT_FLAG);

			Object.entries(state.denial_penalties).forEach(([scoreId, modifier]) => {
				dispatch(`game/scores/${scoreId}/modify`, { amount: modifier }, ROOT_FLAG);
			});

			if (!state.return_if_denied) {
				dispatch("game/chapters/active/disableCurveball", {}, ROOT_FLAG);
			}
		},
		return({ commit }) {
			commit(RETURN_CURVEBALL);
		},
	},
	mutations: {
		[ACCEPT_CURVEBALL](state) {
			state.accepted = true;
		},
		[SET_CURVEBALL_ACTIVATION](state, activation) {
			state.active = activation.active;
		},
		[RETURN_CURVEBALL](state) {
			state.cost = state.return_request.cost;
			state.request_dialogue = state.return_request.request_dialogue;
			state.accept_button_text = state.return_request.accept_button_text;
			state.deny_button_text = "";
			state.returning = true;
			state.videos = { ...state.videos, ...state.return_request.videos };
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/curveballs/single.store.js